import type { CommonParameterMessages } from '../types';

const messages: CommonParameterMessages = {
  'commonParameter.title.addParameter': '添加参数',
  'commonParameter.title.name': '参数名',
  'commonParameter.title.nameNotNull.message': '参数名不能为空!',
  'commonParameter.placeHolder.chooseType': '请选择类型',
} as const;

export default messages;
